// extracted by mini-css-extract-plugin
export default {"assistantAvatar":"Header__assistantAvatar___H9mD1","separator":"Header__separator___K7985","skeleton-loading":"Header__skeleton-loading___FyQzS"};